<script>
import store from '@/state/store';
import { component as Viewer } from 'v-viewer';
// import Loader from "@/components/layout/loader";

export default {
  props: {
    images: {
      required: true,
      type: Array,
      default() {
        return []
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isShowDetails: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    Viewer,
  },
  computed: {
    progress: () => store.state.fileManager.file.file.streamFileProgress || 0,
  },
  data() {
    return {
      options: {
        inline: true,
        button: false,
        navbar: false,
        title: false,
        toolbar: false,  // Changed from toolbar configuration to false to disable entirely
        tooltip: false,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: true,
        fullscreen: false,
        keyboard: true,
        url: 'data-source',
        background: false,
      },

      isImageError: false,
      isImageLoad: false,
      isUpdate: false,
      zoomLevel: 1,
      isFullscreen: false
    }
  },
  methods: {
    // eslint-disable-next-line
    onImageError(data){
      this.isImageError = true;
    },
    // eslint-disable-next-line
    onImageLoad(data){
      this.isImageLoad = true;
    },
    inited(viewer) {
      this.$viewer = viewer
    },
    move(x, y) {
      this.$viewer.move(x, y)
    },
    prev() {
      this.$viewer.prev()
    },
    next() {
      this.$viewer.next()
    },
    play() {
      this.$viewer.play()
    },
    stop() {
      this.$viewer.stop()
    },
    show() {
      this.$viewer.show()
    },
    full() {
      this.isFullscreen = !this.isFullscreen;
      if (this.isFullscreen) {
        this.$viewer.full();
      } else {
        this.$viewer.exit();
      }
    },
    tooltip() {
      this.$viewer.tooltip()
    },
    reset() {
      this.$viewer.reset();
      this.zoomLevel = 1;
    },
    toggleInline(inline) {
      this.options.inline = inline
    },
    zoomIn() {
      this.zoomLevel = Math.min(this.zoomLevel * 1.25, 10);
      this.$viewer.zoom(0.25);
    },
    zoomOut() {
      if (this.zoomLevel > 0.5) {
        this.zoomLevel = Math.max(this.zoomLevel * 0.8, 0.25);
        this.$viewer.zoom(-0.2);
      }
    },
    rotateLeft() {
      this.$viewer.rotate(-90);
    },
    rotateRight() {
      this.$viewer.rotate(90);
    }
  },
  watch: {
    // eslint-disable-next-line
    isShowDetails(newData, oldData) {
      this.isUpdate = true;

      setTimeout(() => {
        this.isUpdate = false;
      }, 10);
    }
  }
}
</script>


<template>
  <div class="tile is-ancestor viewer-container-wrapper">
    <div class="tile is-10 is-vertical is-parent" style="height: 100%;">
      <div class="viewer-wrapper">
        <span v-if="loading || isUpdate" class="h-100 d-flex align-items-center justify-content-center">loading ... {{ progress }}%</span>

        <viewer
          v-else
          ref="viewer"
          :options="options"
          :images="images"
          class="viewer"
          @inited="inited"
        >
          <template #default="scope">
            <figure class="images">
                <div v-for="{ source, fileName } in scope.images" :key="source" class="image-wrapper">
                  <img
                    class="image"
                    :src="source"
                    :data-source="source"
                    :alt="fileName"
                  />
                </div>
            </figure>
          </template>
        </viewer>

        <!-- Custom controls overlay -->
        <div v-if="!loading && !isUpdate" class="viewer-controls">
          <div class="controls-container">
            <button @click="zoomIn" class="control-button" title="Zoom In">
              <i class="mdi mdi-magnify-plus"></i>
            </button>
            <div class="zoom-indicator">{{ Math.round(zoomLevel * 100) }}%</div>
            <button @click="zoomOut" class="control-button" title="Zoom Out">
              <i class="mdi mdi-magnify-minus"></i>
            </button>
            <button @click="reset" class="control-button" title="Reset View">
              <i class="mdi mdi-refresh"></i>
            </button>
            <button @click="rotateLeft" class="control-button" title="Rotate Left">
              <i class="mdi mdi-rotate-left"></i>
            </button>
            <button @click="rotateRight" class="control-button" title="Rotate Right">
              <i class="mdi mdi-rotate-right"></i>
            </button>
            <button @click="full" class="control-button" title="Toggle Fullscreen">
              <i :class="isFullscreen ? 'mdi mdi-fullscreen-exit' : 'mdi mdi-fullscreen'"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<style lang="scss" rel="stylesheet/scss" scoped>
::v-deep .viewer-container {
  width: 100% !important;
}

@media (max-width: 768px) {
  ::v-deep .viewer-container {
    /* Adjust viewer container styles for mobile view */
    width: 100% !important;
    height: 100% !important;
    max-width: 100% !important;
    max-height: 100% !important;
  }
}

.viewer-wrapper {
  position: relative;
  background: #333;
  height: 100%;
}

.methods {
  margin-bottom: 1em;
  flex-wrap: wrap;

  & > * {
    margin-right: 0.75rem;
  }
}

.options-panel {
  .panel-block {
    padding: 0;

    .checkbox {
        display: block;
        width: 100%;
        margin: 0;
        padding: 0.5em 0.75em;
      }
  }
}

.viewer {
  height: 100%;

  .images {
    height: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 5px;

    .image-wrapper {
      // display: inline-block;
      display: none;
      width: calc(33% - 20px);
      margin: 5px 5px 0 5px;

      .image {
        width: 50%;
        cursor: pointer;
        display: inline-block;
      }
    }
  }
}

/* Enhanced styling for loader */
.loader-container {
  background-color: rgba(0, 0, 0, 0.7);
}

.loader-content {
  text-align: center;
}

.progress {
  width: 200px;
  margin: 0 auto;
  height: 5px;
}

/* New styles for viewer controls overlay */
.viewer-controls {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  opacity: 0.2;
  transition: opacity 0.3s ease;
}

.viewer-controls:hover {
  opacity: 1;
}

.controls-container {
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 50px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.control-button {
  background: transparent;
  color: white;
  border: none;
  font-size: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  cursor: pointer;
}

.control-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.control-button:active {
  background-color: rgba(255, 255, 255, 0.2);
}

.zoom-indicator {
  color: white;
  font-size: 14px;
  min-width: 60px;
  text-align: center;
}

.viewer-container-wrapper {
  height: 100%;
}

@media (max-width: 768px) {
  .controls-container {
    padding: 5px 10px;
  }

  .control-button {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }

  .zoom-indicator {
    min-width: 40px;
    font-size: 12px;
  }
}
</style>